var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import CkanSharedTraits from "./CkanSharedTraits";
import GroupTraits from "./GroupTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import UrlTraits from "./UrlTraits";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import { traitClass } from "../Trait";
let CkanCatalogGroupTraits = (_dec = traitClass({
  description: "Creates a group with members from Ckan server.\n\n  <strong>Note:</strong> \n  <br>The following example will</br>\n  <li>Request datasets of specific types only.</li>\n  <li>Organise members in subgroups according to their organisations.</li>\n  <li>For any wms type item, use ESPG:3857 as crs.</li>",
  example: {
    url: "https://discover.data.vic.gov.au/",
    type: "ckan-group",
    name: "DataVic Open Data Portal",
    filterQuery: [{
      fq: '+(res_format:(wms OR WMS OR shapefile OR Shapefile OR "zip (shp)" OR shp OR SHP OR kmz OR GeoJSON OR geojson OR csv-geo-au OR aus-geo-csv))'
    }],
    groupBy: "organization",
    supportedResourceFormats: [{
      id: "WMS",
      urlRegex: "^((?!data.gov.au/geoserver).)*$"
    }, {
      id: "Kml",
      onlyUseIfSoleResource: true
    }, {
      id: "Shapefile",
      onlyUseIfSoleResource: true
    }],
    ungroupedTitle: "Organisation not declared",
    itemPropertiesByType: [{
      type: "wms",
      itemProperties: {
        crs: "EPSG:3857"
      }
    }],
    resourceIdTemplate: "{{resource.name}}-{{resource.format}}",
    restrictResourceIdTemplateToOrgsWithNames: ["department-of-energy-environment-climate-action", "department-of-jobs-skills-industry-regions", "department-of-transport-and-planning", "victorian-electoral-commission"],
    id: "some id"
  }
}), _dec2 = anyTrait({
  name: "Filter Query",
  description: "Gets or sets the filter query to pass to CKAN when querying the available data sources and their groups. Each item in the\n         array causes an independent request to the CKAN, and the results are concatenated.  The\n         search string is equivalent to what would be in the parameters segment of the url calling the CKAN search api.\n         See the [Solr documentation](http://wiki.apache.org/solr/CommonQueryParameters#fq) for information about filter queries.\n         Each item is an object ({ fq: 'res_format:wms' }). For robustness sake, a query string is also allowed. E.g.\n         \"fq=(res_format:wms OR res_format:WMS)\" and \"fq=+(res_format%3Awms%20OR%20res_format%3AWMS)\" are allowed.\n         <li>To get all the datasets with wms resources: [{ fq: 'res_format%3awms' }]</li>\n         <li>To get all wms/WMS datasets in the Surface Water group: [{q: 'groups=Surface Water', fq: 'res_format:WMS' }]</li>\n         <li>To get both wms and esri-mapService datasets: [{q: 'res_format:WMS'}, {q: 'res_format:\"Esri REST\"' }]</li>\n         <li>To get all datasets with no filter, you can use ['']</li>\n       "
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Group By",
  description: "Gets or sets a value indicating how datasets should be grouped.  Valid values are:\n     * none - Datasets are put in a flat list; they are not grouped at all.\n     * group - Datasets are grouped according to their CKAN group.  Datasets that are not in any groups are put at the top level.\n     * organization - Datasets are grouped by their CKAN organization.  Datasets that are not associated with an organization are put at the top level.\n     "
}), _dec4 = primitiveTrait({
  type: "string",
  name: "Ungrouped title",
  description: "A title for the group holding all items that don't have a group in CKAN.\n      If the value is a blank string or undefined, these items will be left at the top level, not grouped."
}), _dec5 = primitiveTrait({
  type: "boolean",
  name: "Allow entire WMS Servers",
  description: "True to allow entire WMS servers (that is, WMS resources without a clearly-defined layer) to be added to the catalog; otherwise, false."
}), _dec6 = primitiveTrait({
  type: "boolean",
  name: "Exclude inactive datasets",
  description: "True to remove inactive datasets. Where `state = \"deleted\"` (CKAN official), `state === \"draft\"` (CKAN official) or `data_state === \"inactive\"` (Data.gov.au CKAN)."
}), _dec7 = primitiveTrait({
  type: "string",
  name: "Resource ID template string.",
  description: "A Mustache formatted template string for generating a custom resource id from resource description. By default we use `resource.id` as the ID of the CKAN item but some CKAN services change their resource IDs frequently which can break terria features link share links or catalog search indexing. You can use `customResourceIdTemplate` to instruct terria to construct a different ID instead of the default `resource.id`. The template string will receive the entire `resource` as a template variable. Example usage: '{{resource.name}}-{{resource.format}}'."
}), _dec8 = primitiveArrayTrait({
  type: "string",
  name: "Restrict resource id template to organization with names",
  description: "Names of organisations for which `customResourceIdTemplate` should be used."
}), _dec(_class = (_class2 = class CkanCatalogGroupTraits extends mixTraits(GroupTraits, UrlTraits, CatalogMemberTraits, LegendOwnerTraits, CkanSharedTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "filterQuery", _descriptor, this);
    _initializerDefineProperty(this, "groupBy", _descriptor2, this);
    _initializerDefineProperty(this, "ungroupedTitle", _descriptor3, this);
    _initializerDefineProperty(this, "allowEntireWmsServers", _descriptor4, this);
    _initializerDefineProperty(this, "excludeInactiveDatasets", _descriptor5, this);
    _initializerDefineProperty(this, "resourceIdTemplate", _descriptor6, this);
    _initializerDefineProperty(this, "restrictResourceIdTemplateToOrgsWithNames", _descriptor7, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "filterQuery", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [{
      fq: '(res_format:(czml OR CZML OR geojson OR GeoJSON OR WMS OR wms OR kml OR KML OR kmz OR KMZ OR WFS OR wfs OR CSV-GEO-AU OR csv-geo-au OR "Esri REST"))'
    }];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "groupBy", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "organization";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "ungroupedTitle", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "No group";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "allowEntireWmsServers", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "excludeInactiveDatasets", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "resourceIdTemplate", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "restrictResourceIdTemplateToOrgsWithNames", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);
export { CkanCatalogGroupTraits as default };